@if (isMobile()) {
  @for (schedule of schedules; track $index; let last = $last) {
    @if (tournamentDetails) {
      <fz-cash-card-details
        [class.mb--2]="!last"
        [schedule]="schedule"
        [tournamentDetails]="tournamentDetails"
        (share)="onShare($event)"
      ></fz-cash-card-details>
    }
  }
} @else {
  <fz-shared-table-component
    [displayedColumns]="displayedColumns"
    [configuration]="configuration"
    [dataSource]="schedules"
    (detailsButtonPressed)="onView($event)"
    (shareButtonPressed)="onShare($event)"
    (elementClicked)="onElementClicked($event)"
  ></fz-shared-table-component>
}
